// this file is auto-generated by pepper

import Logger from '@warbyparker/logger'

let loggerConfig;
try {
  loggerConfig = JSON.parse('{"level":"debug","stdout":true,"stream":{"enabled":true,"level":"warn","enable":false},"environment":{"node_env":"production","hostname":"idp-users.warby.io","type":"build","stage":"Prod"},"codeVersion":"a056dc37b85b993a093158665ed71b918232a0d0"}')
} catch (err) {
  console.error('Error parsing injected logger config')
  throw err
}

export function get(prefix) {
  return new Logger({ ...loggerConfig, name: prefix })
}
